import React from 'react';

interface R2FSaveButtonProps {
    pendingChangeCount: number;
    invalidRowsCount: number;
    isSaveDisabled: boolean;
    onSave: () => void;
    userCanEdit: boolean;
}

/**
 * Save button component for R2F threshold table
 */
export const R2FSaveButton: React.FC<R2FSaveButtonProps> = ({
    pendingChangeCount,
    invalidRowsCount,
    isSaveDisabled,
    onSave,
    userCanEdit
}) => {
    if (!userCanEdit) return null;
    
    return (
        <div className="save-changes-container">
            <div className="change-count">
                {pendingChangeCount > 0 && (
                    <span>{pendingChangeCount} pending change{pendingChangeCount === 1 ? '' : 's'}</span>
                )}
                {invalidRowsCount > 0 && (
                    <span className="error-text">{invalidRowsCount} validation error{invalidRowsCount === 1 ? '' : 's'}</span>
                )}
            </div>
            <button 
                className="save-button primary-button"
                onClick={onSave}
                disabled={isSaveDisabled}
            >
                Save Changes
            </button>
        </div>
    );
};
